import { AEMErrorMessage } from '../../../models';

export const MicromomentErrorMessage: AEMErrorMessage = {
  action: {
    label: 'Learn More About Delta SkyMiles American Express',
    url: '/us/en/skymiles/airline-credit-cards/american-express-personal-cards',
    id: 'learnMoreDeltaSkyMilesAmex'
  },
  component: 'micromoment',
  errorId: [
    {
      errorCode: 'CRD_5002'
    },
    {
      errorCode: 'CRD_2000'
    },
    {
      errorCode: 'CRD_1000'
    },
    {
      errorCode: 'CRD_2006'
    },
    {
      errorCode: 'CRD_5000'
    },
    {
      errorCode: 'CRD_4000'
    },
    {
      errorCode: '702'
    }
  ],
  featureTitle: '',
  errorMessageDescription:
    'Sorry, we’re currently unable to display this micromoment. Please try again later.',
  errorMessageTitle: '',
  type: 'single-error'
};
